<template>
    <main>
        <div class="server-mod">
            <ul class='ul-table'>
                <li class="devices">
                    <label @click="refresh">{{$t('devices.myDevices')}}<i class="icon-icon_repeat refresh-device"></i></label>
                    <div class='devicesContainer'>
                        <div class='top' :class="{'mgt':FEATURE('main.how_to_bind')}">
                            <p class="link" v-if="!FEATURE('main.how_to_bind')">
                                <a class="ui-link" :href="howToBindUrl"  target="_blank">
                                    <span class="text">{{ $t("bindCamera.how_to_bind") }}</span>
                                    <span class="ui-icon icon-icon_arrow-right"></span>
                                </a>
                            </p>
                        </div>
                        <ReoTabBox
                            :leftTabText="$t('devices.tabs.my_devices_cloud')"
                            :rightTabText="$t('devices.tabs.sim')"
                            :defaultTab="currentTab"
                            @tabChange="val=>currentTab=val"
                        />
                        <div class='bottom'>
                            <KeepAlive>
                                <CloudDevices v-if="currentTab" ref="cloudDevices"/>
                                <SimList v-else ref="simList"/>
                            </KeepAlive>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </main>
</template>

<script lang="ts">
import Vue from 'vue';
import CloudDevices from './components/CloudDeviceList/index.vue';
import ReoTabBox from '@/components/ReoTabBox.vue';
import SimList from '@/components/SimList.vue';
import { getQueryParam } from '@/common/js/utils';

export default Vue.extend({
    components: {
        CloudDevices,
        ReoTabBox,
        SimList
    },
    data() {

        const tab = getQueryParam( this.$route, 'tab', 'cloud' )[0];

        return {
            currentTab: tab === 'sim' ? false : true
        };

    },
    computed: {
        howToBindUrl (): string {

            return this.$tc( 'dashboard.bind_url' );

        }
    },
    methods: {
        async refresh() {

            const cloudDevices = this.$refs.cloudDevices as InstanceType<typeof CloudDevices>;
            const simList = this.$refs.simList as InstanceType<typeof SimList>;
            if ( cloudDevices ) {

                await cloudDevices.refreshDevicesList();

            } else if ( simList ) {

                simList.refresh();

            }

        }
    }
});
</script>

<style lang="less" scoped>

    .server-mod{
        padding-top: 0;
        margin-top: 62px;
        margin-bottom: 41px;
    }
    .server-mod > ul > li{
        display: flex;
        flex-direction: column;
    }
    .server-mod .link{
        margin-bottom: 0.24rem;
        line-height: 1.2;
        @media @mobile{
            text-align: center;
        }
    }

    .ul-table{
        @media @pc{
            width: 1000px;
            margin: 0 auto;
        }
    }
    .devices{

        & > label{
            flex-shrink: 0;
            width: unset;
            font-size: .22rem;
            font-weight: 500;
            color: #333;
            vertical-align: middle;
            line-height: 1.2;
        }
        @media @mobile{
            flex-direction: column;
            & > label{
                text-align: center;
                font-size: 20px;
            }
        }
        .devicesContainer{
            display: flex;
            flex-direction: column;
            .top.mgt{
                margin-top:.24rem;
            }
            @media @mobile{
                padding-left: .3rem;
                padding-right: .3rem;
                .top{
                    padding-right: .3rem;

                }
            }
        }
    }
    .link{
        margin-top: .12rem;
        margin-bottom: .24rem;
        line-height: 1.2;
        &.bottom-lab-link {
            padding-left: 0.3rem;
        }
        & + .link {
            margin-top: 0.2rem;
        }
        .lab-icon {
            position: absolute;
            font-size: 0.24rem;
            color: @theme;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
        }
    }
    @media @mobile {
        .link {
            margin-bottom: .3rem;
            padding-left: 0;
            &.bottom-lab-link {
                padding-left: 0.52rem;
            }
            .lab-icon {
                font-size: 0.4rem;
            }
            & + .link {
                margin-top: 0.3rem;
            }
        }
    }
    .refresh-device{
        display: inline-block;
        margin-left: 8px;
        font-size: 18px;
        color: @theme;
        cursor: pointer;
    }

</style>
